import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useTranslation from '../../../hooks/use-translation';
const FontAwesomeComponent = ({ className, color, icon, title, translationObject }) => {
    const t = useTranslation();
    return (_jsx(FontAwesomeIcon, { "aria-hidden": true, className: className, color: color, icon: icon, role: "graphics-symbol", size: "1x", title: translationObject ? t(`${translationObject}.${title}`) : title }));
};
export default FontAwesomeComponent;
//# sourceMappingURL=index.js.map